import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import env from '../misc/env';
import { createIamAPI } from './API';
import Invitation from './Invitation';
var InvitationStore = /*#__PURE__*/function (_Store) {
  function InvitationStore() {
    var _this;
    _classCallCheck(this, InvitationStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, InvitationStore, [].concat(args));
    /**
     * Pending team invites
     */
    _this.pendingMembers = _this.collection({
      model: Invitation
    });
    /**
     * IAM API.
     */
    _this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    return _this;
  }
  _inherits(InvitationStore, _Store);
  return _createClass(InvitationStore, [{
    key: "get",
    value:
    /**
     * Gets an invite by token.
     *
     * @param {*} idOrToken
     */
    function get(idOrToken) {
      return this.api.invitations.get(idOrToken);
    }

    /**
     * Invites a user to a workspace (and optionally a  team)
     *
     * @param {*} payload
     */
  }, {
    key: "invite",
    value: function invite(payload) {
      return this.api.invitations.create(payload);
    }

    /**
     * Accepts an invitation
     *
     * @param {*} payload
     */
  }, {
    key: "accept",
    value: function accept(payload) {
      return this.api.invitations.accept(payload);
    }

    /**
     * Gets the pending invites for a team
     *
     * @param  {*} payload
     */
  }, {
    key: "findPending",
    value: (function () {
      var _findPending = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var pendingData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.api.invitations.findPending(payload);
            case 2:
              pendingData = _context.sent;
              this.pendingMembers.set(pendingData.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function findPending(_x) {
        return _findPending.apply(this, arguments);
      }
      return findPending;
    }())
  }]);
}(Store);
export { InvitationStore as default };
//# sourceMappingURL=InvitationStore.js.map
